import axios from 'axios';
import { BASE_URL } from './helpers';
import { MediaOutputSpec } from './structs/media-spec';
import { AIVideoSettingsPayload } from './media';

/**
 * The output spec a standalone generation carries.
 *
 * NESTED, not flat: the backend's `models.MediaOutputSpec` keeps one settings
 * block per modality, and the reference inputs a video takes
 * (`reference_images` / `reference_audios` / `reference_videos`, flat lists of
 * media id or URL) live inside the `ai_video` block — never at the top level,
 * where the handler would not see them.
 */
export interface StandaloneOutputSpec {
  image?: Record<string, unknown>;
  ai_video?: AIVideoSettingsPayload & Record<string, unknown>;
  audio?: Record<string, unknown>;
}

export interface StandaloneGenerateRequest {
  type: 'image' | 'ai_video' | 'audio';
  prompt: string;
  generator?: string;
  model?: string;
  /** Media ids to condition generation on (img2img identity reference). */
  reference_media_ids?: string[];
  output_spec?: StandaloneOutputSpec | MediaOutputSpec;
  metadata?: Record<string, unknown>;
}

export interface StandaloneGenerateResponse {
  media_id: string;
  status: string;
}

const generateMedia = async (request: StandaloneGenerateRequest): Promise<StandaloneGenerateResponse> => {
  return axios.post(`${BASE_URL}/media/generate`, request).then((res) => res.data);
};

const GenerateAPI = {
  generateMedia,
};

export default GenerateAPI;
